import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
// import { NotificationsService } from 'angular2-notifications';
import { BaseDataService, BaseUpdateComponent, ModalService, NotificationService } from 'yt-ng-framework';
import { RadnoMestoPoslovi } from './radno-mesto-poslovi';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-radno-mesto-poslovi-update',
  templateUrl: './radno-mesto-poslovi-update.component.html'
})
export class RadnoMestoPosloviUpdateComponent 
  extends BaseUpdateComponent<RadnoMestoPoslovi>
  implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService,
    protected modalService: ModalService
  ) { 
    super(activatedRoute, baseDataService, toastrService, translateService,modalService);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  ngAfterViewInit()
  {
    setTimeout(()=>{
      this.baseFormGroup.get("Naziv").disable();
      this.baseFormGroup.get("Sifra").disable();
    }, 0)
  }
}
